import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import Badge from 'react-bootstrap/Badge';
import Table from 'react-bootstrap/Table';
import DashboardLayout from './DashboardLayout';
import ReducedContent from './ReducedContent';
import { Alert, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { fetchSubjects, deleteSubject } from '../../api/api';

const SubjectList = () => {
  const [pageMessage, setPageMessage] = useState("Buscando matérias...");
  const [subjects, setSubjects] = useState([]);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchSubjects();
        if (response.length === 0) {
          setPageMessage("Nenhuma matéria encontrada");
          return;
        }
        setSubjects(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleDelete = async (subject_uuid) => {
    try {
      const deleted = await deleteSubject(subject_uuid);
      deleted ? setShowSuccessAlert(true) : setShowErrorAlert(true);
    } catch (error) {
      console.error("Error deleting data:", error);
    }
    setTimeout(() => {
      setShowSuccessAlert(false);
      setShowErrorAlert(false);
    }, 3000);
  };

  const handleEdit = (subject_uuid) => navigate('/dashboard/subject/edit/' + subject_uuid);

  return (
    <DashboardLayout title="Matérias">
      <ReducedContent>
        {showSuccessAlert && <Alert variant="success">Matéria deletada com sucesso!</Alert>}
        {showErrorAlert && <Alert variant="danger">Erro ao deletar matéria.</Alert>}

        {subjects.length > 0 ? (
          <Table hover responsive>
            <colgroup>
              <col style={{ width: '5%' }} />
              <col style={{ width: '50%' }} />
              <col style={{ width: '10%' }} />
              <col style={{ width: '10%' }} />
              <col style={{ width: '20%' }} />
            </colgroup>
            <thead>
              <tr>
                <th>#</th>
                <th>Nome</th>
                <th>Categorias</th>
                <th>Atividades</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {subjects.map((subject, index) => (
                <tr key={subject.uuid}>
                  <td>{index + 1}</td>
                  <td>{subject.name}</td>
                  <td><Badge bg="primary">{subject.category_count}</Badge></td>
                  <td><Badge bg="secondary">{subject.activity_count}</Badge></td>
                  <td>
                    <Button
                      variant={subject.read_only ? "outline-secondary" : "outline-primary"}
                      size="sm"
                      onClick={() => handleEdit(subject.uuid)}
                      disabled={subject.read_only}
                      title={subject.read_only ? "Read-only" : "Edit"}
                    >
                      <FontAwesomeIcon icon={faPencilAlt} />
                    </Button>{' '}
                    <Button
                      variant={subject.read_only ? "outline-secondary" : "outline-danger"}
                      size="sm"
                      onClick={() => handleDelete(subject.uuid)}
                      disabled={subject.read_only}
                      title={subject.read_only ? "Read-only" : "Delete"}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p>{pageMessage}</p>
        )}
      </ReducedContent>
    </DashboardLayout>
  );
};

export default SubjectList;
